<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col pr-0">
          <h3 class="page-title">List of Class Subjects</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            :disabled="!schoolId && tokenObj.UserType == userTypeMainAdmin"
            type="button"
            class="btn add-btn"
            @click="add"
          >
            <i class="fa fa-plus"></i>Add Class Subject
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <div class="row align-items-center">
      <div class="col-12">
        <select
          v-if="tokenObj.UserType == userTypeMainAdmin"
          v-model="schoolId"
          class="form-control fit-content"
        >
          <option value="">-- Please Select School --</option>
          <option v-for="item in schools" :value="item.Id" :key="item.Id">
            {{ item.Name }}
          </option>
        </select>
      </div>
    </div>
    <!-- /Form -->

    <!-- Table -->
    <div class="row mt-3">
      <div class="col-md-12">
        <div
          class="table-responsive mb-lg-0 mb-md-0 mb-sm-1"
          v-if="schoolId || tokenObj.UserType != userTypeMainAdmin"
        >
          <form id="saveForm" @submit.prevent="save"></form>
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th class="subject-col">
                  <button class="btn p-0" @click="setSortBy('subject')">
                    Class Subject
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'subject'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'subject_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="sequence-col">
                  <button class="btn p-0" @click="setSortBy('sequence')">
                    Sequence
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'sequence'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'sequence_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="showAddMode" class="table-info">
                <td class="no-col"></td>
                <td class="subject-col">
                  <input
                    type="text"
                    class="form-control"
                    v-model="formData.name"
                    maxlength="100"
                    form="saveForm"
                    required
                  />
                </td>
                <td class="sequence-col">
                  <input
                    type="number"
                    class="form-control"
                    v-model="formData.sortOrder"
                    step="1"
                    min="1"
                    max="100"
                    form="saveForm"
                    required
                  />
                </td>
                <td class="action-col">
                  <button
                    type="submit"
                    class="btn btn-sm btn-link p-0"
                    form="saveForm"
                  >
                    <i class="fa fa-save mr-1"></i>Update
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-link p-0"
                    @click="cancel"
                  >
                    <i class="far fa-window-close-o mr-1 ml-3"></i>Cancel
                  </button>
                </td>
              </tr>
              <tr v-for="(item, i) in subjects" :key="item.Id">
                <template v-if="formData.id !== item.Id">
                  <td class="no-col">{{ i + 1 }}</td>
                  <td class="subject-col">{{ item.Name }}</td>
                  <td class="sequence-col">{{ item.SortOrder }}</td>
                  <td class="action-col">
                    <button @click="edit(item)" class="btn btn-sm btn-link p-0">
                      <i class="far fa-edit mr-1"></i>Edit
                    </button>
                    <button
                      @click="remove(item.Id)"
                      class="btn btn-sm btn-link p-0"
                    >
                      <i class="fa fa-trash-o mr-1 ml-3"></i>Delete
                    </button>
                  </td>
                </template>
                <template v-else>
                  <td class="no-col">{{ i + 1 }}</td>
                  <td class="subject-col table-info">
                    <input
                      type="text"
                      class="form-control"
                      v-model="formData.name"
                      maxlength="100"
                      form="saveForm"
                      required
                    />
                  </td>
                  <td class="sequence-col table-info">
                    <input
                      type="number"
                      class="form-control"
                      v-model="formData.sortOrder"
                      step="1"
                      min="1"
                      max="100"
                      form="saveForm"
                      required
                    />
                  </td>
                  <td class="action-col table-info">
                    <button
                      type="submit"
                      class="btn btn-sm btn-link p-0"
                      form="saveForm"
                    >
                      <i class="fa fa-save mr-1"></i>Update
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-link p-0"
                      @click="cancel"
                    >
                      <i class="far fa-window-close-o mr-1 ml-3"></i>Cancel
                    </button>
                  </td>
                </template>
              </tr>
              <tr v-if="!subjects.length && !showAddMode" class="text-center">
                <td colspan="4">{{ noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table -->
  </div>
</template>


<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
export default {
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      noRecordText: config.NO_RECORD_TEXT,
      showAddMode: false,
      schools: [],
      schoolId: "",
      subjects: [],
      subjectId: "",
      formData: {
        id: "",
        name: "",
        sortOrder: "",
      },
      paging: { SortBy: "" },
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  watch: {
    schoolId(val) {
      this.showAddMode = false;
      this.resetForm();
      if (val) {
        this.paging.SortBy = "";
        this.getSubjects();
      } else this.subjects = [];
    },
  },

  methods: {
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSubjects() {
      let param = {
        Token: this.tokenObj.Token,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        SortBy: this.paging.SortBy,
      };
      this.$store.state.isLoading = true;
      API.subject
        .getSubjects(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.subjects = response.data.records;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //action
    resetForm() {
      this.formData = {
        id: "",
        name: "",
        sortOrder: "",
      };
    },
    add() {
      this.showAddMode = true;
      this.resetForm();
      //set default sequence to next number
      let nextSequence = 1;
      if (this.subjects.length) {
        let maxSequence = this.subjects.reduce(
          (max, obj) => (obj.SortOrder > max ? obj.SortOrder : max),
          this.subjects[0].SortOrder
        );
        nextSequence = maxSequence + 1;
      }
      this.formData.sortOrder = nextSequence;
    },
    edit(payload) {
      this.showAddMode = false;
      this.resetForm();
      this.formData.id = payload.Id;
      this.formData.name = payload.Name;
      this.formData.sortOrder = payload.SortOrder;
    },
    cancel() {
      this.showAddMode = false;
      this.resetForm();
      this.getSubjects();
    },
    remove(Id) {
      let param = {
        Token: this.tokenObj.Token,
        Id: Id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the subject?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.subject
            .deleteSubject(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    save() {
      let param = {
        Token: this.tokenObj.Token,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        Id: this.formData.id,
        Name: this.formData.name,
        SortOrder: this.formData.sortOrder,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the subject?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.subject
            .saveSubject(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    //sorting
    setSortBy(payload) {
      switch (payload) {
        case "subject":
          if (this.paging.SortBy === "subject") {
            this.paging.SortBy = "subject_desc";
          } else if (this.paging.SortBy === "subject_desc") {
            this.paging.SortBy = "subject";
          } else {
            this.paging.SortBy = "subject";
          }
          break;
        case "sequence":
          if (this.paging.SortBy === "sequence") {
            this.paging.SortBy = "sequence_desc";
          } else if (this.paging.SortBy === "sequence_desc") {
            this.paging.SortBy = "sequence";
          } else {
            this.paging.SortBy = "sequence";
          }
          break;
      }
      this.getSubjects();
    },
  },

  created() {
    if (this.tokenObj.UserType == this.userTypeMainAdmin) this.getSchools();
    if (
      this.tokenObj.UserType == this.userTypeSchoolAdmin ||
      this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin
    )
      this.getSubjects();
  },
};
</script>

<style scoped>
.sequence-col {
  width: 15%;
}
.action-col {
  width: 25%;
}

@media only screen and (max-width: 767.98px) {
  table {
    width: 700px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassSubjectList.vue